import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Slide } from 'react-reveal'

import Icon from '../../../../components/ui/Icon/Icon'
import LoadingBase from '../../../../components/loading/LoadingBase/LoadingBase'
import CardList from '../../../../components/home/CardList/CardList'
import AddCardSuccessModal from '../../../../components/home/AddCardSuccessModal/AddCardSuccessModal'
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import CardsError from '../../../../components/home/CardsError/CardsError'

import {
  BANNER_ADS,
  BANNER_ADS_EMPTY,
} from '../../../../services/data/errorNames.json'
import { MAIN } from '../../../../services/data/profilePages.json'
import getErrorType from '../../../../services/data/getCardErrorType'
import * as CardApiService from '../../../../services/api/requests/Card'
// import * as GCashApiService from '../../../../services/api/requests/GCash'

import {
  DetailPageContainer,
  Header,
  ReturnIcon,
  Title,
  Content,
  StyledAddCardPageForm,
  MainPage,
  BannerAdsContainer,
  LoadingBannerAdCard,
  BannerAdContainer,
  BannerAd,
  PageContent,
  // ErrorMessage,
} from './ManageCardsPage.style'

const cardErrorDefaultType = {
  errorType: null,
  display: false,
}
class ManageCardsPage extends React.Component {
  constructor(props) {
    super(props)

    this.bannerAdsSlider = React.createRef()

    this.state = {
      cardList: [],
      errorMessage: '',
      loadingStatus: null,
      showAddCardForm: false,
      showSuccessModal: false,
      bannerAds: [],
      cardError: cardErrorDefaultType,
    }
  }

  componentDidMount() {
    this.getBannerAds()
    this.loadCardList()
  }

  getBannerAds = () => {
    const { doGetAllAds } = this.props
    doGetAllAds &&
      doGetAllAds({
        setBannerAds: this.handleGetAllAds,
        onEmpty: this.onEmptyBannerAds,
        onError: this.onErrorBannerAds,
      })
  }

  onErrorBannerAds = () => {
    const { setError } = this.props
    setError({ name: BANNER_ADS })
  }

  onEmptyBannerAds = () => {
    const { setError } = this.props
    setError({ name: BANNER_ADS_EMPTY })
  }

  handleGetAllAds = data => {
    this.setState({
      bannerAds: data,
    })
  }

  handleSuccessModalClose = () => {
    this.setState({
      showSuccessModal: false,
    })
  }

  handleSuccess = () => {
    this.toggleShowAddCardForm(false)

    this.loadCardList()

    this.setState({
      showSuccessModal: true,
    })
  }

  handleDelete = async id => {
    const { accessToken } = this.props
    const { cardList } = this.state

    try {
      await CardApiService.deleteCard(id, accessToken)

      this.setState({
        cardList: cardList.filter(card => card.id !== id),
      })
    } catch (err) {
      this.setState({
        errorMessage: 'Unable to Delete Card',
      })
    }
  }

  toggleShowAddCardForm = show => {
    this.setState({
      showAddCardForm: show,
    })
  }

  loadCardList = async () => {
    this.setState({
      loadingStatus: 0,
      cardList: [],
    })

    const { accessToken } = this.props

    try {
      const { data: cardsData } = await CardApiService.getAllCards(accessToken)
      this.setState({
        loadingStatus: 1,
        cardList: cardsData,
        cardError: cardErrorDefaultType,
      })
    } catch (error) {
      const { data: errorData = {} } = error.response || {}
      const { message = 'Network Error' } = errorData || {}

      this.setState({
        loadingStatus: 4,
        // errorMessage: 'Unable to Retrieve Cards',
        cardError: {
          type: getErrorType(message),
          display: true,
        },
      })
    }
  }

  render() {
    const {
      cardList,
      showAddCardForm,
      // errorMessage,
      loadingStatus,
      showSuccessModal,
      bannerAds,
      cardError,
    } = this.state
    const { setProfileModalPage, primaryInfo, errorList } = this.props
    const {
      firstName,
      // , lastName
    } = primaryInfo || {}
    // const fullName = `${firstName} ${lastName}`

    const AddCardForm = ({ show }) => {
      return (
        <Slide right duration={200}>
          <DetailPageContainer show={show}>
            {!!show && (
              <>
                <Header>
                  <ReturnIcon onClick={() => this.toggleShowAddCardForm(false)}>
                    <Icon name="slide-left" />
                  </ReturnIcon>
                  <Title>Add Card</Title>
                </Header>
                <Content>
                  <PageContent>
                    <StyledAddCardPageForm onSuccess={this.handleSuccess} />
                  </PageContent>
                </Content>
              </>
            )}
          </DetailPageContainer>
        </Slide>
      )
    }

    return (
      <>
        <MainPage show={!showAddCardForm}>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>Manage Cards</Title>
          </Header>
          <Content>
            {errorList &&
              !errorList.find(error => error.name === BANNER_ADS_EMPTY) && (
                <BannerAdsContainer>
                  <CardSlider
                    dataSource={bannerAds}
                    loadingComponent={() => (
                      <LoadingBannerAdCard
                        key={JSON.stringify(errorList)}
                        loading
                        error={errorList.find(
                          error => error.name === BANNER_ADS,
                        )}
                        onRetry={this.getBannerAds}
                      />
                    )}
                    renderItem={item => {
                      const image = item.images.find(
                        img => img.type === 'BANNER',
                      )
                      return (
                        <BannerAdContainer>
                          <BannerAd
                            key={item.id}
                            alt={item.title}
                            src={image.imageUrl}
                          />
                        </BannerAdContainer>
                      )
                    }}
                    ref={this.bannerAdsSlider}
                    bannerAds
                  />
                </BannerAdsContainer>
              )}
            <CardsError
              display={cardError.display}
              errorType={cardError.type}
              onRetry={this.loadCardList}
            />
            <PageContent>
              {/* <ErrorMessage>{errorMessage}</ErrorMessage> */}
              {loadingStatus === 0 && <LoadingBase />}
              <CardList
                items={cardList}
                onDelete={this.handleDelete}
                onAddClick={() => this.toggleShowAddCardForm(true)}
                firstName={firstName}
                loadingStatus={loadingStatus}
                hasCardError={cardError.display}
              />
            </PageContent>
          </Content>
        </MainPage>
        <AddCardForm show={showAddCardForm} />

        <AddCardSuccessModal
          show={showSuccessModal}
          onClose={this.handleSuccessModalClose}
          card={cardList.length ? cardList[cardList.length - 1] : {}}
        />
      </>
    )
  }
}

ManageCardsPage.defaultProps = {
  primaryInfo: {},
}

ManageCardsPage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default ManageCardsPage
